import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../icons";
import { AlertRecord, apiFetch } from "../../../api";

export function ThreatDetectionPanel() {
  const { t, i18n } = useTranslation("dashboard");
  const [alert, setAlert] = useState<AlertRecord | null>(null);

  useEffect(() => {
    const tick = async () => {
      try {
        const list = await apiFetch<AlertRecord[]>("/api/v1/alerts");
        const open = list.filter((a) => a.status.toLowerCase() === "open");
        // En öncelikli critical -> high -> medium.
        const order = (s: string) =>
          s === "critical" ? 3 : s === "high" ? 2 : s === "medium" ? 1 : 0;
        open.sort(
          (a, b) =>
            order(b.severity.toLowerCase()) - order(a.severity.toLowerCase()),
        );
        setAlert(open[0] ?? null);
      } catch {
        // silent
      }
    };
    void tick();
    const t = setInterval(tick, 15_000);
    return () => clearInterval(t);
  }, []);

  if (!alert) {
    return (
      <>
        <header className="panel-head">
          <h3>
            <Icon name="shield" size={18} /> {t("panels.threat.title")}
          </h3>
          <span className="panel-tag">{t("panels.threat.noOpenTag")}</span>
        </header>
        <div className="empty-card">
          <Icon name="check" /> {t("panels.threat.noOpenCard")}
        </div>
      </>
    );
  }

  const severity = alert.severity.toLowerCase();
  const ring =
    severity === "critical" ? 92 : severity === "high" ? 75 : severity === "medium" ? 55 : 30;
  const label =
    severity === "critical" || severity === "high"
      ? t("panels.threat.high")
      : t("panels.threat.medium");
  return (
    <>
      <header className="panel-head">
        <h3>
          <Icon name="shield" size={18} /> {t("panels.threat.title")}
        </h3>
        <span className="panel-tag">{t("panels.threat.vehicleTag", { id: alert.vehicle_id })}</span>
      </header>
      <div className="threat-body">
        <div className="threat-level">
          <div className="threat-ring" style={{ background: `conic-gradient(#f43f5e 0% ${ring}%, rgba(244,63,94,0.12) ${ring}% 100%)` }}>
            <div className="threat-ring-value">{ring}%</div>
            <div className="threat-ring-label">{t("panels.threat.severity")}</div>
          </div>
          <div className="threat-summary">
            <span className="threat-grade-label">{t("panels.threat.threatLevel")}</span>
            <span className="threat-grade">{label}</span>
          </div>
        </div>
        <div>
          <div className="threat-section-title">{t("panels.threat.detection")}</div>
          <div className="muted small">{alert.summary || alert.code}</div>
        </div>
        <div>
          <div className="threat-section-title">{t("panels.threat.time")}</div>
          <div className="muted small">
            {new Date(alert.occurred_at).toLocaleString(i18n.resolvedLanguage)}
          </div>
        </div>
      </div>
    </>
  );
}
